import script from "./comment.vue?vue&type=script&lang=ts&setup=true"
export * from "./comment.vue?vue&type=script&lang=ts&setup=true"

import "./comment.vue?vue&type=style&index=0&id=b633cc4c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b633cc4c"]])

export default __exports__